import { VideoPlayerCardStyled } from '@styled/video-player-card.styled';
import { useRef, useState } from 'react';

interface VideoPlayerCardProps {
  src: string;
  poster: string;
}

export const VideoPlayerCard = ({ src, poster }: VideoPlayerCardProps) => {
  const [videoPlaying, setVideoPlaying] = useState(false);
  const videoPlayerRef = useRef<HTMLVideoElement>(null);

  const pauseVideo = () => {
    if (!videoPlayerRef.current) return;
    try {
      videoPlayerRef.current?.pause();
    } catch (e) {
      console.error(e);
    }
  };

  const playVideo = async () => {
    if (!videoPlayerRef.current) return;
    try {
      await videoPlayerRef.current?.play();
    } catch (e) {
      console.error(e);
    }
  };

  const onVideoPlayerClick = () => {
    if (!videoPlaying) playVideo();
    else pauseVideo();
    setVideoPlaying((prev) => !prev);
  };
  return (
    <VideoPlayerCardStyled
      ref={videoPlayerRef}
      onClick={onVideoPlayerClick}
      src={src}
      poster={poster}
    />
  );
};
